import { render, staticRenderFns } from "./input-placeholder.vue?vue&type=template&id=3ea41c81&"
import script from "./input-placeholder.vue?vue&type=script&lang=js&"
export * from "./input-placeholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports